import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import React, { Component } from 'react'
import classnames from 'classnames'
import Immutable, { Map } from 'immutable'
import Input from 'shared-web/src/components/Input'
import IconSVG from 'svg-inline-react'
import _keyBy from 'lodash/keyBy'
import Access from 'utils/Access'
import { connect } from 'react-redux'
import * as GatesSelectors from 'app/modules/gates/selectors'
import * as DemandbaseEnrichmentSelectors from 'app/modules/enrichment/demandbase/selectors'
import { fetchDemandbaseTargetingIndustries, fetchDemandbaseTargetingSubIndustries } from 'app/modules/enrichment/demandbase/actions'
import { patchOperations } from 'utils/PatchHelper'
import { Select } from '@driftt/tide-core-legacy'
import colors from 'styles/colors'
import TargetConditionTypes, { getTargetCondition } from './TargetConditionTypes'
import Modal from 'components/shared/Modal'
import style from './style'

import { createTarget, updateTarget } from 'app/modules/targeting/actions'
import { wasTargetCreated, lastCreatedTargetId, wasTargetUpdated, lastUpdatedTargetId } from 'app/modules/targeting/selectors'
import { isConnectedTo } from 'app/modules/integrations/selectors'
import { isIntegrationConnected } from 'utils/Integrations'

function DeleteButton({ onClick }) {
  return (
    <div
      onClick={ onClick }
      className="delete-button"
    >
      <IconSVG
        className="gray-icon"
        style={{ width: 12, height: 16 }}
        element="div"
        src={ require('!svg-inline?removeTags=true!images/svg/delete.svg') }
      />
    </div>
  )
}

function AddConditionCta({ onClick }) {
  return (
    <div className={classnames(style.TargetConditions, 'flex-center')}>
      <a
        className="dsg-Link"
        onClick={onClick}
      >
        Click here to add a new condition
      </a>
    </div>
  )
}

function AddConditionButton({ onClick }) {
  return (
    <div
      className="dsg-IconButton2 add-condition"
      style={{ backgroundColor: colors["color-green"] }}
      onClick={ onClick }
    >
      <IconSVG
        style={{ width: 8, height: 8, marginRight: 6 }}
        element="div"
        src={ require('!svg-inline?removeTags=true!images/svg/plus.svg') }
      />
      AND
    </div>
  )
}

function AddConditionSetButton({ onClick }) {
  return (
    <div
      className="dsg-IconButton2 add-condition-set"
      style={{ backgroundColor: colors["color-green"] }}
      onClick={onClick}
    >
      <IconSVG
        style={{ width: 8, height: 8, marginRight: 6 }}
        element="div"
        src={require('!svg-inline?removeTags=true!images/svg/plus.svg')}
      />
      OR
    </div>
  )
}

class TargetConditionEditModal extends Component {
  static contextTypes = {
    app: PropTypes.object
  }

  getTargetConditionTypes = () => {
    return Map(TargetConditionTypes)
      .filter((condition) => this.isValidCondition(condition))
      .toJS()
  }

  constructor(props) {
    super(props)
    let target = {}
    if (props.editTarget) {
      target = props.editTarget
    }
    target = Immutable.fromJS(target)
    this.state = { target: target, ogTarget: target }
  }

  componentDidMount() {
    const { actions, hasDemandbase } = this.props
    
    if (hasDemandbase) {
      actions.fetchDemandbaseTargetingIndustries()
      actions.fetchDemandbaseTargetingSubIndustries()
    } 
  }

  componentDidUpdate(prevProps) {
    if (this.props.wasTargetUpdated !== prevProps.wasTargetUpdated) {
      this.context.app.queries.DefaultEmbedQueries.refreshDefaultEmbed(this.props.org.id)
        .then(() => {
          this.props.onSave(this.props.lastUpdatedTargetId)
          this.props.onClose()
        })
    }

    if (this.props.wasTargetCreated !== prevProps.wasTargetCreated) {
      this.props.onSave(this.props.lastCreatedTargetId)
      this.props.onClose()
    }
  }

  isValidCondition = (condition) => {
    if (!!condition.gates && !Access.hasGates(condition.gates)) {
      return false
    } else if (!!condition.requiredIntegration && !isIntegrationConnected(condition.requiredIntegration)) {
      return false
    }

    return true
  } 

  makeChangeHandler(key) {
    return (input) => {
      const target = this.state.target.set(key, input)
      this.setState({ target })
    }
  }

  handleAddNewOrCondition = () => {
    let conditions = this.state.target.get('conditions')
    const types = _.values(this.getTargetConditionTypes())
    const typeToAdd = types && types[0]
    if (!typeToAdd) return
    conditions = conditions || Immutable.List()
    conditions = conditions.push(Immutable.List([Immutable.fromJS(typeToAdd.default)]))
    this.updateConditions(conditions)
  }

  handleAddCondition = (outerIndex) => {
    let conditions = this.state.target.get('conditions')
    const types = _.values(this.getTargetConditionTypes())
    const typeToAdd = types && types[0]
    if (!typeToAdd) return
    conditions = conditions.set(outerIndex, (conditions.get(outerIndex) || Immutable.List()).push(Immutable.fromJS(typeToAdd.default)))
    this.updateConditions(conditions)
  }

  updateTarget(target) {
    this.setState({ target })
  }

  updateConditions(conditions) {
    this.updateTarget(this.state.target.set('conditions', conditions))
  }

  makeOnConditionSelection(innerIndex, outerIndex) {
    return (value) => {
      if (value !== null){
        const selected = this.getTargetConditionTypes()[value.value]
        const target = this.state.target.setIn(['conditions', outerIndex, innerIndex], Immutable.fromJS(selected.default))
        this.updateTarget(target)
      }
    }
  }

  makeConditionUpdater(innerIndex, outerIndex) {
    return (key, value) => {
      const target = this.state.target.setIn(['conditions', outerIndex, innerIndex, key], value)
      this.updateTarget(target)
    }
  }

  renderConditions() {
    const conditions = this.state.target.get('conditions')
    return conditions.map(((condition, outerIndex) => {
      return [
        !!outerIndex && <div className="or-condition">OR</div>,
        <div className={style.TargetConditions}>
          {condition.map((_condition, innerIndex) => {
            const isLastCondition = innerIndex === condition.size - 1
            return [
              !!innerIndex && <div className="and-condition">AND</div>,
              this.renderCondition(_condition, innerIndex, outerIndex),
              isLastCondition && <AddConditionButton onClick={() => this.handleAddCondition(outerIndex)} />
            ]
          })}
        </div>
      ]
    })
    )
  }

  renderCondition(condition, innerIndex, outerIndex) {
    const selectedCondition = getTargetCondition(condition.get('field'), condition.get('operator'))
    if (!selectedCondition) {
      throw new Error(`target condtion type not found for ${ JSON.stringify(condition.toJS()) }`)
    }
    const options = _.sortBy(_.map(this.getTargetConditionTypes(), (value, key) => {
      return { value: key, label: value.display }
    }), ({ text }) => text)
    const filteredOptions = _.filter(options, (option) => {
      return option.value !== 'TeamHours' || !!this.props.hasTeamHours
    })
    return (
      <div className={ style.TargetCondition }>
        <Select
          size="small"
          onChange={this.makeOnConditionSelection(innerIndex, outerIndex) }
          options={ filteredOptions }
          value={ {value: selectedCondition.default.field, label: selectedCondition.display} }
          clearable={false}
        />
        <selectedCondition.component
          conditionValue={ condition }
          conditionUpdater={this.makeConditionUpdater(innerIndex, outerIndex)}
          {...this.props}
        />
        <DeleteButton onClick={ () => {
          const conditions = this.state.target.get('conditions')
          const newInnerCondition = conditions.get(outerIndex).delete(innerIndex)
          const newConditions = newInnerCondition.size === 0
            ? conditions.delete(outerIndex)
            : conditions.set(outerIndex, conditions.get(outerIndex).delete(innerIndex))
          this.updateConditions(newConditions)
        }}/>
      </div>
    )
  }

  canSave() {
    return !this.validateName() &&
      this.state.ogTarget !== this.state.target &&
      this.areConditionsValid()
  }

  handleSaveClick = () => {
    if (!this.canSave()) return
    const target = this.state.target.toJS()

    if (!this.props.editTarget) {
      this.props.actions.createTarget(target)
    } else {
      const operations = patchOperations(target, this.props.editTarget)
      if (_.isEmpty(operations)) return
      this.props.actions.updateTarget({ operations, targetId: target.id })
    }
  }

  /**
   * return a validation error if any for the name
   * @returns {string}
   */
  validateName() {
    const name = this.state.target.get('name')
    if (!name) {
      return 'Need a name'
    }
    const isItsOwnName = this.props.editTarget && name === this.props.editTarget.name
    if (!this.props.targets || isItsOwnName) return
    const nameTaken = _keyBy(this.props.targets, 'name')[name]
    if (nameTaken) return 'Name taken'
  }

  areConditionsValid() {
    const conditions = this.state.target.get('conditions')
    if (!conditions || !conditions.size) return false
    return true
  }

  renderNameInput() {
    const invalidLabel = this.validateName()
    return (
      <Input
        valueLink={{
          requestChange: this.makeChangeHandler('name'),
          value: this.state.target.get('name')
        }}
        isValid={ !invalidLabel }
        invalidLabel={ invalidLabel }
        label="Name condition set"
      />
    )
  }

  render() {
    const conditions = this.state.target.get('conditions')
    return (
      <Modal
        onRequestClose={ this.props.onClose }
        modalContentClassName={ style.TargetModal }
        isOpen
        style={{
          overlay: {
            maxHeight: '100vh',
            overflowY: 'auto',
          },
          content: {
            padding: 0,
            width: 850,
            maxHeight: '90%',
            overflow: 'auto',
            minHeight: 500,
          },
        }}
      >
        <div className={ classnames("flex-space-between", style.TargetModal__Header) }>
          <div className="dsg-h3">
            Display When...
          </div>
          <div className="flex-space-between">
            <a className="dsg-Label--gray" style={{ marginRight: '1rem' }} onClick={ this.props.onClose }>
              Cancel
            </a>
            <button
              className="dsg-MediumButton"
              disabled={ !this.canSave() }
              onClick={ this.handleSaveClick }
            >
              Save
            </button>
          </div>
        </div>
        <div className={ style.TargetModal__Content }>
          { this.renderNameInput() }
          <div className="flex-space-between helper-text">
            Display to visitors who match the following conditions:
          </div>
          {conditions && conditions.size ? this.renderConditions() : <AddConditionCta onClick={() => this.handleAddNewOrCondition() } /> }
          <AddConditionSetButton onClick={this.handleAddNewOrCondition} />
        </div>
        <a className="widget-targeting-help-link" target="_blank" href="https://help.drift.com/targeting/display-when">Learn more about targeting with Drift</a>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      createTarget,
      updateTarget,
      fetchDemandbaseTargetingIndustries,
      fetchDemandbaseTargetingSubIndustries,
    },
    dispatch
  ),
})

const mapStateToProps = (state) => {
  return {
    hasTeamHours: GatesSelectors.hasTeamHours(state),
    hasDemandbase: isConnectedTo(state, 'demandbase'),
    wasTargetCreated: wasTargetCreated(state),
    wasTargetUpdated: wasTargetUpdated(state),
    lastCreatedTargetId: lastCreatedTargetId(state),
    lastUpdatedTargetId: lastUpdatedTargetId(state),
    demandbaseIndustries: DemandbaseEnrichmentSelectors.demandbaseTargetingIndustries(state),
    demandbaseSubIndustries: DemandbaseEnrichmentSelectors.demandbaseTargetingSubIndustries(state)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TargetConditionEditModal)



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/TargetConditionInput/TargetConditionEditModal/index.js